<template>
  <div id="container">
    <div style="margin-top:20px;background:#fff;padding:20px;border-radius: 4px;">
      <div>
        <span class="bold"></span>
        <span
          class="basic"
          style="vertical-align: middle">公司信息</span>
      </div>
      <el-form
        :model="queryParams"
        :rules="queryParamsRules"
        ref="queryParamsRefs">
        <el-form-item
          label="公司名称："
          label-width="150px"
          style="margin-top:30px;"
          prop="comName">
          <el-input
            v-model="queryParams.comName"
            :disabled="isedit"
            placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item
          label="法人："
          label-width="150px"
          :disabled="isedit"
          style="margin-top:30px;">
          <el-row>
            <el-col :span="10">
              <el-input
                v-model="queryParams.comLegal"
                placeholder="请输入法人名称"
                :disabled="isedit"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="公司地址："
          label-width="150px"
          :disabled="isedit"
          style="margin-top:30px;">
          <el-row>
            <el-col :span="10">
              <el-input
                v-model="queryParams.comAddress"
                placeholder="请输入公司地址"
                :disabled="isedit"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="公司邮箱："
          label-width="150px"
          style="margin-top:30px;">
          <el-row>
            <el-col :span="10">
              <el-input
                v-model="queryParams.comEmail"
                placeholder="请输入公司邮箱"
                :disabled="isedit"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="公司电话："
          label-width="150px"
          style="margin-top:30px;">
          <el-row>
            <el-col :span="10">
              <el-input
                v-model="queryParams.comPhone"
                :disabled="isedit"
                placeholder="请输入公司电话"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-button
        v-if="isedit"
        type="info"
        plain
        @click="isedit=false"
        style="background: #fff">修改
      </el-button>
      <el-button
        type="primary"
        v-else
        style="background-color: #fff;color:#ffffff"
        @click="toModify('queryParamsRefs')"
        class="fl"
      >保存
      </el-button>
    </div>
  </div>
</template>
<script>
  /**
   * company   添加方法
   *
   */

  import { getCompany, company } from '@/api/system/rightsManagement'

  var _this
  export default {
    data () {
      return {
        isedit: true,

        SavedSuccess: false,
        queryParams: {},
        queryParamsRules: {
          //
          comName: [{
            required: true,
            message: '请输入公司名称',
            trigger: ['blur']
          }],
          comPhone: [
            {
              required: true,
              message: '请输入公司电话',
              trigger: ['blur']
            }
          ],
          comLegal: [
            {
              required: true,
              message: '请输入法人名称',
              trigger: ['blur']
            }
          ],
          comAddress: [
            {
              required: true,
              message: '请输入公司地址',
              trigger: ['blur']
            }
          ],
          comEmail: [
            {
              required: true,
              message: '请输入公司邮箱',
              trigger: ['blur']
            }
          ]
        }
      }
    },
    created () {
      // this.getList()// 初始化系数初始值
    },
    mounted () {
      _this = this
      _this.getList()
    },
    methods: {
      // 获取系数初始值
      getList () {
        getCompany().then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj
          }
        })
      },
      // 保存
      toSave () {
        // 表单校验
        this.$refs.queryParamsRefs.validate(async vaild => {
          if (!vaild) {
            this.$message.error('必填项不可为空！')
            return false
          }
          this.SavedSuccess = false
        })
      },
      // 修改
      toModify (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            company(this.queryParams).then(res => {
              this.$message({
                message: res.data.msg,
                type: res.data.code === 200 ? 'success' : 'error'
              })
              this.isedit = !this.isedit
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style
  lang='less'
  scoped>
  #container {
    .el-input {
      display: block;
      width: 480px;
    }
  }

  /deep/ .el-button--info.is-plain {
    color: rgb(78, 85, 91);
  }
</style>
